import { CompProps } from '@fable/types'
import { StatsBackground } from '../StatsBackground'
import { css } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { StatsHero } from '../stats_hero'
import { useReaderSummary } from '../../lib/ctx/reader_summary'

export const ReaderSummaryContainer = ({ children }: CompProps) => {
  const status = useReaderSummary((s) => s.status)
  const [theme, isProfileView, isV2, goalOptIn] = useStats((s) => [
    s.theme,
    s.isProfileView,
    s.isV2,
    s.goalOptIn,
  ])

  if (isProfileView) {
    return (
      <div
        data-testid="stats-reader-summary-profile"
        className={css`
          margin-bottom: 20px;
          width: 100%;
          padding: 16px;
          min-height: 60px;
          position: relative;
          padding-top: ${status !== 'hidden' || goalOptIn ? '40px' : '0'};
        `}
      >
        <div
          className={css`
            background-color: ${theme.primary};
            border-radius: 20px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
          `}
        >
          <StatsBackground />
          <span
            className={css`
              display: block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 100px;
              background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0),
                ${theme.summaryBg} 70%
              );
            `}
          />
        </div>
        <div
          className={css`
            position: relative;
            z-index: 1;
          `}
        >
          {isV2 ? <StatsHero /> : null}
          {children}
        </div>
      </div>
    )
  }

  return <>{children}</>
}
